module.exports = __webpack_public_path__ + "img/right-link-banner.64f0f483.png";